<template>
  <template v-if="!edit">
    <ul v-if="original.options && Array.isArray(original.options) && original.options.length > 0" class="text-sm list-inline">
      <li v-for="(option, idx) in original.options" :key="idx">
        <span class="font-semibold">{{ option.label }}:</span> {{ value && value[option.label] ? 'Sim':'Não' }}
      </li>
    </ul>
    <span v-else class="text-sm">
      Sem resposta 
    </span>
  </template>
  
  <CheckboxGroupAnswer v-else v-bind="$attrs" class="w-full" no-label :question="original"/>
</template>


<script>

import CheckboxGroupAnswer from '#views/questionnaire/answers/CheckboxGroupAnswer';

export default {
  name: "CheckboxGroupDetail",
  inheritAttrs: false,
  components: {
    CheckboxGroupAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    emitModelValue(value) {
      this.$emit("update:modelValue", !Array.isArray(value) ? value:{});
    }
  },
  mounted(){
    this.emitModelValue(this.value);
  },
  watch: {
    value(newer){
      this.emitModelValue(newer);
    }
  }
};
</script>
